export enum ADMIN_STAFF_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
  DELETE = 'D',
}

export interface AdminStaff {
  staffId: string;
  username: string;
  emailAddress: string;
  phoneNumber: number;
  role: string;
  roleId: string;
  createdDate: string;
  status: ADMIN_STAFF_STATUS;
  profileImage: { alt: string; description: string; path: string } | undefined;
}

export interface AdminParams {
  fromDate?: number;
  toDate?: number;
  search?: string;
  row?: number;
  fetch?: number;
}
